import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowUpRight } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { projects } from "@/content/projects";
import { breadcrumbScript, SITE_URL } from "@/lib/seo";

export const Route = createFileRoute("/projects/")({
  head: () => ({
    meta: [
      { title: "Website projects and case studies | Phil Carr" },
      {
        name: "description",
        content:
          "Selected SEO, web design, WordPress and ecommerce projects delivered by Phil Carr.",
      },
      { property: "og:title", content: "Website projects and case studies | Phil Carr" },
      {
        property: "og:description",
        content:
          "Selected SEO, web design, WordPress and ecommerce projects delivered by Phil Carr.",
      },
      { property: "og:url", content: `${SITE_URL}/projects` },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/projects` }],
    scripts: [
      breadcrumbScript([
        { name: "Home", url: `${SITE_URL}/` },
        { name: "Projects", url: `${SITE_URL}/projects` },
      ]),
    ],
  }),
  component: ProjectsPage,
});

function ProjectsPage() {
  return (
    <>
      <PageHero
        title="Website projects and case studies"
        backgroundImage="/images/brand/web-design-1200.webp"
      />
      <section className="inner-content-section container mx-auto max-w-7xl px-6 py-16 sm:px-8 lg:px-10 lg:py-24">
        <div className="grid gap-8 lg:grid-cols-2">
          {projects.map((project) => (
            <article
              key={project.slug}
              className="demo-card demo-card-hover flex h-full flex-col overflow-hidden"
            >
              <img
                src={project.image}
                alt={`${project.client} website project`}
                width={1200}
                height={675}
                loading="lazy"
                decoding="async"
                className="h-72 w-full object-cover"
              />
              <div className="flex flex-1 flex-col p-8">
                <p className="demo-section-label">{project.sector}</p>
                <h2 className="demo-card-title mt-4 font-display text-3xl">{project.shortTitle}</h2>
                <p className="demo-card-text mt-4 text-muted-foreground">{project.description}</p>
                <ul className="mt-6 grid gap-2 pl-0 text-sm text-muted-foreground">
                  {project.outcomes.slice(0, 2).map((outcome) => (
                    <li key={outcome}>{outcome}</li>
                  ))}
                </ul>
                <Link
                  to="/projects/$slug"
                  params={{ slug: project.slug }}
                  className="demo-link-arrow-button demo-card-cta mt-auto pt-8"
                >
                  View case study
                  <span className="demo-arrow-circle">
                    <ArrowUpRight className="h-4 w-4" />
                  </span>
                </Link>
              </div>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
